{
  "en": {
    "dashboard": {
      "greetings": {
        "afternoon": "Good afternoon {first_name}",
        "evening": "Good evening {first_name}",
        "morning": "Good morning {first_name}",
        "night": "Good night {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "You have no open items right now.",
        "caught_up_title": "You're all caught up",
        "status_active": "In progress",
        "status_completed": "Completed",
        "status_planned": "Planned",
        "todo_now_title": "What to do now",
        "journey_title": "Your journey",
        "journey_select_unit_title": "Select a unit",
        "journey_select_unit_subtitle": "Choose a unit above to view its journey.",
        "journey_no_active_title": "No active milestone",
        "journey_no_active_subtitle": "This unit has not started its journey yet.",
        "progress_completed": "{completed} / {total} completed",
        "previous_label": "Previous milestones",
        "completed_count": "{count} completed",
        "upcoming_more": "{count} more upcoming milestones",
        "open_action": "Open",
        "due_before": "Before {date}",
        "show_more_tasks": "Show {count} more task | Show {count} more tasks",
        "show_less": "Show less"
      },
      "titles": {
        "activityFeed": "Activity Feed",
        "assignedTasks": "My Tasks",
        "newsFeed": "News Feed",
        "ongoingTickets": "Ongoing",
        "openTickets": "Open",
        "progress": "Progress",
        "tickets": "Conversations",
        "totalTickets": "All conversations",
        "unreadTickets": "Unread",
        "yourAssignedTickets": "Assigned to you"
      }
    }
  }
}
